import React from 'react'
import { Gift, Edit, Trash2, AlertCircle } from 'lucide-react'
import { Benefit } from '../../types'
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell, Button } from '../ui'
import { formatCurrency } from '../../utils/formatters'

interface BenefitsListViewProps {
 benefits: Benefit[]
 onEditBenefit: (benefit: Benefit) => void
 onDeleteBenefit: (id: string) => void
}

export const BenefitsListView: React.FC<BenefitsListViewProps> = ({
 benefits,
 onEditBenefit,
 onDeleteBenefit
}) => {
 if (benefits.length === 0) {
 return (
 <div className="text-center py-12">
 <AlertCircle className="h-12 w-12 text-muted-foreground mx-auto mb-4"/>
 <h3 className="text-lg font-medium text-foreground mb-2">
 Nenhum benefício encontrado
 </h3>
 <p className="text-muted-foreground">
 Crie seu primeiro benefício para começar.
 </p>
 </div>
 )
 }

 return (
 <div className="overflow-x-auto">
 <Table>
 <TableHeader>
 <TableRow>
 <TableHead>Nome</TableHead>
 <TableHead>Valor</TableHead>
 <TableHead className="text-right">Ações</TableHead>
 </TableRow>
 </TableHeader>
 <TableBody>
 {benefits.map((benefit) => (
 <TableRow key={benefit.id}>
 <TableCell>
 <div className="flex items-center gap-2">
 <Gift className="h-4 w-4 text-accent"/>
 <p className="font-medium text-foreground">
 {benefit.name}
 </p>
 </div>
 </TableCell>
 
 <TableCell>
 <span className="font-medium text-foreground">
 {formatCurrency(benefit.value)}
 </span>
 </TableCell>
 
 <TableCell className="text-right">
 <div className="flex items-center justify-end gap-2">
 <Button
 variant="outline"
 size="sm"
 onClick={() => onEditBenefit(benefit)}
 >
 <Edit className="h-4 w-4"/>
 </Button>
 <Button
 variant="outline"
 size="sm"
 onClick={() => onDeleteBenefit(benefit.id)}
 className="text-red-600 hover:text-red-700 hover:bg-red-50 dark:hover:bg-red-900/20"
 >
 <Trash2 className="h-4 w-4"/>
 </Button>
 </div>
 </TableCell>
 </TableRow>
 ))}
 </TableBody>
 </Table>
 </div>
 )
}

